import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import lodashPick from 'lodash/pick';

import {
  SCREEN_ID_PREQUAL_FORM_START_PAGE,
  SCREEN_ID_LISTING_CHOOSE_TOUR_TIME,
} from 'client/constants/screenIds';

import {
  APPLICATION_FORM_TYPE_RENTER_PREQUAL,
} from 'common/householdApplication/applicationFormFields';

import log from 'client/lib/log';
import getLastPageVisitedByScreenIdList from 'common/util/getLastPageVisitedByScreenIdList';
import redirectToApplicationFormAction from 'client/actions/Household/redirectToApplicationForm';
import updateRenterProfileAction from 'client/actions/Household/updateRenterProfile';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import SrLink from 'client/components/SrLink/SrLink';
import SrFlex from 'client/components/SrFlex';
import Navbar from 'client/components/Navbar';
import ButtonDeprecated from 'client/components/ButtonDeprecated';
import branch from 'client/core/branch';

import {
  TOUR_REQUEST_SHOWING_FIELDS,
} from 'common/tourConstants';

@withTransitionHook
@withScreenId(SCREEN_ID_PREQUAL_FORM_START_PAGE)
@branch({
  currentUserId: ['currentUser', 'id'],
  screenIdHistory: ['analytics', 'screenIdHistory'],
  pathHistory: ['analytics', 'pathHistory'],
})
@withScrollToTop
class PrequalFormStartPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Prequal | Sunroom Rentals',
  })

  static propTypes = {
    currentUserId: PropTypes.number.isRequired,
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    screenIdHistory: PropTypes.array.isRequired,
    pathHistory: PropTypes.array.isRequired,
  }

  _onStartPrequalButtonClick = () => {
    const {
      currentUserId,
      location,
      dispatch,
    } = this.props;

    const locationQuery = queryString.parse(location.search || '');

    const requestedShowing = lodashPick(locationQuery, TOUR_REQUEST_SHOWING_FIELDS);

    dispatch(updateRenterProfileAction, {
      userId: currentUserId,
      updates: {
        hasStartedPrequal: true,
      },
    })
      .then(() => {
        return dispatch(redirectToApplicationFormAction, {
          formType: APPLICATION_FORM_TYPE_RENTER_PREQUAL,
          requestedShowing,
        });
      })
      .catch((error) => {
        log.error(error);
      });
  }

  render() {
    const {
      screenIdHistory,
      pathHistory,
    } = this.props;

    const lastPageVisited = getLastPageVisitedByScreenIdList({
      screenIdHistory,
      pathHistory,
      screenIdList: [
        SCREEN_ID_LISTING_CHOOSE_TOUR_TIME,
      ],
    });

    return (
      <div className='page-prequal-intro'>
        <Navbar
          leftButton={(
            <SrLink
              to={lastPageVisited ? lastPageVisited.path : '/tour'}
              className='link back'
            />
          )}
        />
        <div className='icon' />
        <div className='contentContainer'>
          <SrFlex justify='center' align='center'>
            <div className='step'>
              <div className='headline'>
                <span>Awesome! You're almost there!</span>
              </div>
              <div className='bodyText'>
                <span>
                  Please complete a few quick questions to ensure you're a match for the home.
                </span>
              </div>
            </div>
          </SrFlex>
          <div className='buttonContainer'>
            <ButtonDeprecated onClick={this._onStartPrequalButtonClick}>
              continue
            </ButtonDeprecated>
          </div>
        </div>
      </div>
    );
  }
}

PrequalFormStartPage.displayName = 'PrequalFormStartPage';

export default PrequalFormStartPage;
